import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ARCINTBSolutions, ARCTBCFSolutions } from "../../types";
import { buildMLCSolutions } from "../MLCServices/MLCHelper";
import { getFactoryConfigs } from "./factoryConfigServices";

interface MLCFactoryConfigSolutionsType { solutions: string[], dryers: string[], isCLApplicable: boolean, processLines: string[] };
const getMLCFactoryConfigSolutions = (): Observable<MLCFactoryConfigSolutionsType> => getFactoryConfigs().pipe(
    map(({ solutions, dryers, isCLApplicable, processLines }) => ({ solutions, dryers, isCLApplicable, processLines }))
);

export const getINTBMLCFactorySolutions = () => getMLCFactoryConfigSolutions().pipe(
    map(({ solutions, ...rest }) => ({
        ...rest,
        solutions: solutions.filter(el => Object.values(ARCINTBSolutions).includes(el as ARCINTBSolutions)) as ARCINTBSolutions[]
    })),
    map(({ solutions, isCLApplicable, ...rest }) => {
        solutions.forEach(el => {
            // BC & BS from config, means that from SSE we get to BC -> BC, BR to BS -> BS, BU
            if (el === ARCINTBSolutions.BC) {
                solutions.push(ARCINTBSolutions.BR);
                return;
            }
            if (el === ARCINTBSolutions.BS) {
                solutions.push(ARCINTBSolutions.BU);
                return;
            }
        });
        isCLApplicable && solutions.push(ARCINTBSolutions.CL);
        return { solutions, ...rest };
    }),
    map(({ dryers, solutions, processLines }) => processLines.reduce((acc, value) => {
        return Object.assign(acc, { [value]: buildMLCSolutions(solutions, dryers, value, true) })
    }, {})),
);

export const getTBCFMLCFactorySolutions = () => getMLCFactoryConfigSolutions().pipe(
    map(({ dryers, solutions }) => ({
        dryers,
        solutions: solutions.filter(el => Object.values(ARCTBCFSolutions).includes(el as ARCTBCFSolutions)) as ARCTBCFSolutions[]
    })),
    map(({ dryers, solutions }) => buildMLCSolutions(solutions, dryers, null, false)),
);